import { PORTRAIT_URL, SITE } from "../lib/site";

export const PortraitFrameImg = ({ withCaption }) => (
  <div className="relative">
    <div className="absolute -inset-3 border border-gold/25" />
    <div className="relative aspect-[3/4] overflow-hidden bg-ink-700">
      {PORTRAIT_URL ? (
        <>
          <img src={PORTRAIT_URL} alt="Maria João Nepomuceno, Advogada" className="w-full h-full object-cover photo-warm" style={{ objectPosition: "center 18%" }} />
          <div className="photo-tint" />
        </>
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-serif text-7xl md:text-8xl text-gold/60">MJN</span>
          <span className="label-caps mt-6">Retrato · Portrait</span>
        </div>
      )}
      {withCaption && (
        <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/75 via-black/30 to-transparent">
          <div className="font-serif text-xl text-[#F7F2E9]">{SITE.name}</div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-gold-light mt-1 font-sans font-medium" style={{ color: "#E4C9A0" }}>Advogada · {SITE.cedula}</div>
        </div>
      )}
    </div>
  </div>
);
